import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface ButtonSpinnerProps {
    size: number;
    color: string;
}

const ButtonSpinner: React.FC<ButtonSpinnerProps> = ({ size, color }) => {
    return (
        <div style={{
            position: 'relative',
            width: `${size}px`,
            height: `${size}px`,
        }}>
            <div style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                border: `2px solid ${color}`,
                borderRadius: '50%',
                animation: 'spinner-rotate 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
                borderColor: `${color} transparent transparent transparent`,
            }} />
            <div style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                border: `2px solid ${color}`,
                borderRadius: '50%',
                animation: 'spinner-rotate 1.8s cubic-bezier(0.5, 0, 0.5, 1) infinite',
                borderColor: `transparent ${color} transparent transparent`,
                animationDelay: '-0.3s',
            }} />
            <div style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                border: `2px solid ${color}`,
                borderRadius: '50%',
                animation: 'spinner-rotate 1.5s cubic-bezier(0.5, 0, 0.5, 1) infinite',
                borderColor: `transparent transparent ${color} transparent`,
                animationDelay: '-0.6s',
            }} />
            <style>
                {`
          @keyframes spinner-rotate {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
            </style>
        </div>
    );
};

const LoadingSpinner: React.FC = () => {
    const { theme } = useTheme();

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100%',
            backgroundColor: theme.colors.BACKGROUND,
            color: theme.colors.TEXT,
            gap: theme.spacing.MEDIUM,
        }}>
            <div style={{
                position: 'relative',
                width: '48px',
                height: '48px',
            }}>
                <div style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    border: `4px solid ${theme.colors.PRIMARY}`,
                    borderRadius: '50%',
                    animation: 'spinner-rotate 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
                    borderColor: `${theme.colors.PRIMARY} transparent transparent transparent`,
                }} />
                <div style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    border: `4px solid ${theme.colors.PRIMARY}`,
                    borderRadius: '50%',
                    animation: 'spinner-rotate 1.8s cubic-bezier(0.5, 0, 0.5, 1) infinite',
                    borderColor: `transparent ${theme.colors.PRIMARY} transparent transparent`,
                    animationDelay: '-0.3s',
                }} />
                <div style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    border: `4px solid ${theme.colors.PRIMARY}`,
                    borderRadius: '50%',
                    animation: 'spinner-rotate 1.5s cubic-bezier(0.5, 0, 0.5, 1) infinite',
                    borderColor: `transparent transparent ${theme.colors.PRIMARY} transparent`,
                    animationDelay: '-0.6s',
                }} />
            </div>
            <style>
                {`
          @keyframes spinner-rotate {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
            </style>
        </div>
    );
};

export { ButtonSpinner };
export default LoadingSpinner; 